export const TvIcon = () => [
  <svg viewBox="0 0 26 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0 0H26V16H15V18L21 18V20L5 20V18H11V16H0V0ZM2 2V14H24V2H2Z"
      fill="currentColor"
    />
  </svg>
];
